import { Form } from 'antd';
import * as Components from 'components';
import { RevenueShareInterface } from 'content/type';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { RevenueShareFilter } from '../components/RevenueShareFilter';
import { RevenueShareTable } from '../components/RevenueShareTable';
import { getRevenueShareFilterHandler } from '../handlers/revenueShareFilterHandler';
import { revenueShareService } from '../services/revenueShareService';

export const RevenueShare: React.FC = () => {
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams({
    start_yearmon: '2024-01',
    end_yearmon: '2024-12',
    group_by: 'season',
  });
  const [filterParams, setFilterParams] = useState<Record<string, string>>({
    start_yearmon: '2024-01',
    end_yearmon: '2024-12',
    group_by: 'season',
  });

  const { handleApplyFilters, handleOnClickFilterReset } = getRevenueShareFilterHandler({
    setSearchParams,
    filterParams,
  });

  const fetchRevenue = useCallback(
    async (params: URLSearchParams): Promise<{ data: RevenueShareInterface[]; count: number }> => {
      const queryParams = {
        page: params.get('page') ?? '',
        page_size: params.get('page_size') ?? '',
        title: params.get('title') ?? '',
        start_yearmon: params.get('start_yearmon') ?? '',
        end_yearmon: params.get('end_yearmon') ?? '',
        contract_id: params.get('contract_id') ?? '',
        content_provider_id: params.get('content_provider_id') ?? '',
        group_by: params.get('group_by') ?? '',
      };
      const filteredParams = Object.fromEntries(
        Object.entries(queryParams).filter(([_, value]) => value !== 'undefined' && value !== '')
      );
      const revenueData = await revenueShareService.fetchShare(filteredParams);
      return { data: revenueData.results, count: revenueData.count };
    },
    [searchParams]
  );

  useEffect(() => {
    form.setFieldsValue({
      start_yearmon: dayjs(searchParams.get('start_yearmon')),
      end_yearmon: dayjs(searchParams.get('end_yearmon')),
      content_provider_ids: searchParams.get('content_provider_ids')?.split(',').filter(Boolean),
      season_ids: searchParams.get('season_ids')?.split(',').filter(Boolean),
      group_by: searchParams.get('group_by'),
    });
  }, [searchParams]);

  return (
    <Components.BasePageComponent>
      <RevenueShareFilter
        form={form}
        searchParams={searchParams}
        handleFilterValueChange={setFilterParams}
        handleFilterSubmit={handleApplyFilters}
        handleFilterReset={handleOnClickFilterReset}
      />
      <RevenueShareTable
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        dataFetch={fetchRevenue}
      />
    </Components.BasePageComponent>
  );
};

export default RevenueShare;
